import { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { generatePassword } from 'utils'
import { showAlert } from 'services/alerts.service'
import ModalComponent from 'components/common/ModalComponent'
import FormFooter from 'components/System/FormFooter'
import PasswordField from 'components/System/PasswordField'
import { systemRequest, getRequestErrorMessage } from 'components/System/systemRequest'

const ResetPasswordModal = ({ isOpen, farmId, user, onClose, onSaved }) => {
  const { t } = useTranslation()
  const [saving, setSaving] = useState(false)
  const initialData = useMemo(() => ({ password: generatePassword(12) }), [user, isOpen])

  const handleSave = async ({ password }) => {
    if (!password || password.length < 8) {
      showAlert({ message: t('system.tenants.form.passwordHint'), icon: 'warning' })
      return
    }
    setSaving(true)
    try {
      await systemRequest('PUT', `/system/tenants/${farmId}/users/${user.userId}/password`, { password })
      showAlert({ message: t('system.tenants.passwordForm.updated', { email: user.email }), icon: 'success' })
      onSaved()
    } catch (error) {
      showAlert({ message: getRequestErrorMessage(error, t('system.tenants.form.saveError')), icon: 'error' })
    } finally {
      setSaving(false)
    }
  }

  return (
    <ModalComponent
      isOpen={isOpen}
      onClose={onClose}
      title={t('system.tenants.passwordForm.title', { email: user?.email || '' })}
      initialData={initialData}
      onSave={handleSave}
      maxWidth='md'
      customFooter={<FormFooter onClose={onClose} saving={saving} />}
    >
      {({ formData, handleChange }) => (
        <PasswordField value={formData.password} onChange={handleChange} />
      )}
    </ModalComponent>
  )
}

export default ResetPasswordModal
